import { __awaiter, __generator } from "tslib";
export function createInternalExports(_a) {
    var _this = this;
    var context = _a.context;
    /* istanbul ignore next */
    var getExpressCheckoutSettings = function () { return __awaiter(_this, void 0, void 0, function () {
        var ecommerceSettings;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0: return [4 /*yield*/, ((_a = context.eCommerceSettingsService) === null || _a === void 0 ? void 0 : _a.getEcommerceSettings())];
                case 1:
                    ecommerceSettings = _l.sent();
                    return [2 /*return*/, {
                            taxOnProduct: Boolean((_b = ecommerceSettings === null || ecommerceSettings === void 0 ? void 0 : ecommerceSettings.tax) === null || _b === void 0 ? void 0 : _b.taxIncludedInItemPrices),
                            isExpressSupported: !((_d = (_c = ecommerceSettings === null || ecommerceSettings === void 0 ? void 0 : ecommerceSettings.checkoutSettings) === null || _c === void 0 ? void 0 : _c.checkoutFields) === null || _d === void 0 ? void 0 : _d.delayCaptureEnabled),
                            hasPolicies: Boolean((_g = (_f = (_e = ecommerceSettings === null || ecommerceSettings === void 0 ? void 0 : ecommerceSettings.checkoutSettings) === null || _e === void 0 ? void 0 : _e.checkoutPolicies) === null || _f === void 0 ? void 0 : _f.termsAndConditions) === null || _g === void 0 ? void 0 : _g.visible),
                            requirePolicyAgreement: Boolean((_k = (_j = (_h = ecommerceSettings === null || ecommerceSettings === void 0 ? void 0 : ecommerceSettings.checkoutSettings) === null || _h === void 0 ? void 0 : _h.checkoutFields) === null || _j === void 0 ? void 0 : _j.policyAgreementCheckbox) === null || _k === void 0 ? void 0 : _k.visible),
                        }];
            }
        });
    }); };
    return {
        expressCheckout: {
            settings: getExpressCheckoutSettings,
        },
    };
}
//# sourceMappingURL=wixcode.internal.js.map